module.exports = "/_next/static/images/46ca6bac84e780905e16bd1ae9b37b6d-nubanker-xpeer@3x.jpg";